import React, { useContext, useEffect, useState } from "react";
import Header from "./Comman/Header";
import { OnmaxContext } from "../OnmaxContext";
import axios from "axios";
import Pagination from "./Comman/Pagination";

export default function DepositHistory() {
  const { formatDateTime } = useContext(OnmaxContext);
  const [data, setdata] = useState([]);
  const [isLoading, setisLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [pages, setPages] = useState(1);
  const username = localStorage.getItem("username");


  const getData = async () => {
    if (!username) {
      return;
    }
    setisLoading(true);

    await axios
      .post(process.env.REACT_APP_BACKEND_LINK, {
        method: "deposit",
        submethod: "getbydeid",
        username: username,
        key: process.env.REACT_APP_KEY,
        page: currentPage,
        pageSize: pageSize,

      })
      .then((res) => {
        setisLoading(false);

        // var dedata = decryptData(res.data);
        if (res.data.error) {
          return "";
        }
        setdata(res.data.data);
        setPages(Math.ceil(res.data.total / pageSize));

      });
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    getData();
  }, [username, pageSize, currentPage]);


  return (
    <>
      <div className="body-bg">
        <Header />
        <section className="nftmax-adashboard nftmax-show mt-4 setting-section">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-12">

                {/* Card Container */}
                <div className="db-profile-card mb-5">

                  {/* Card Header */}
                  <div className="db-sec-hdr">
                    <div className="db-sec-dot"></div>
                    <div className="db-sec-title">Deposit History</div>
                  </div>

                  <div className="card-body p-0 mt-3">
                    <div className="table-responsive">
                      <table className="table table-dashboard-premium align-middle mb-0" style={{ minWidth: '700px' }}>
                        <thead className="text-uppercase small">
                          <tr>
                            <th scope="col" className="ps-4 py-3" style={{ width: '10%' }}>Sr.</th>
                            <th scope="col" className="py-3" style={{ width: '40%' }}>From</th>
                            <th scope="col" className="py-3" style={{ width: '25%' }}>Amount</th>
                            <th scope="col" className="pe-4 py-3 text-end" style={{ width: '25%' }}>Date</th>
                          </tr>
                        </thead>
                        <tbody>
                          {isLoading && !data.length ? (
                            <tr>
                              <td colSpan="4" className="text-center py-5">
                                <div className="spinner-border text-primary" role="status">
                                  <span className="visually-hidden">Loading...</span>
                                </div>
                              </td>
                            </tr>
                          ) : !data.length ? (
                            <tr>
                              <td colSpan="4" className="text-center py-5 text-slate-400">
                                <p className="mb-0">No data found</p>
                              </td>
                            </tr>
                          ) : (
                            data.map((ele, i) => {
                              const index = currentPage * pageSize - pageSize + (i + 1);
                              return (
                                <tr key={i} className="table-tr-premium">
                                  <td className="ps-4">
                                    <span className="text-slate-400 small">{index}</span>
                                  </td>

                                  <td>
                                    <div className="d-flex align-items-center">
                                      <div className="bg-soft-primary rounded-circle p-2 me-3 d-flex align-items-center justify-content-center" style={{ width: '30px', height: '30px' }}>
                                        <i className="fa fa-arrow-down text-primary text-xs"></i>
                                      </div>
                                      <span className="text-white-custom fw-semibold">
                                        {ele.fusername ? (ele.fusername === "1169158525" ? "From Getlink" : ele.fusername) : "Self"}
                                      </span>
                                    </div>
                                  </td>

                                  <td>
                                    <span className="fw-bold text-success fs-6">+${ele.amount}</span>
                                  </td>

                                  <td className="pe-4 text-end">
                                    {ele.date ? (
                                      <span className="text-slate-400 small">{formatDateTime(ele.date)}</span>
                                    ) : '-'}
                                  </td>
                                </tr>
                              );
                            })
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>

                  {/* Card Footer for Pagination */}
                  <div className="card-footer bg-transparent border-top border-secondary border-opacity-10 p-4">
                    <Pagination
                      currentPage={currentPage}
                      setCurrentPage={setCurrentPage}
                      pageSize={pageSize}
                      setPageSize={setPageSize}
                      pages={pages}
                    />
                  </div>

                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
